<div class="box-form-ui container upload-documents">
  <h2>Adjunta el/los siguiente(s) documento(s):</h2>

  <form
    id="FormUploadDocuments"
    class="form-upload-documents"
    [formGroup]="uploadDocumentsPresignedForm"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
  >
    <div class="note" *ngIf="groupAttachIdGroup.enabled">
      <span class="number">1</span>
      <p class="content">
        Carga por separado la parte frontal y el reverso de tu cédula. Si le vas
        a tomar una foto, ponla en posición horizontal y apaga el flash.
      </p>
    </div>
    <section
      class="card attach-box"
      *ngIf="groupAttachIdGroup.enabled"
      formGroupName="attachIdGroup"
    >
      <div class="attach-container front-id">
        <h3><strong>Parte frontal de tu cédula</strong></h3>
        <label
          for="FrontIDPic"
          [ngClass]="{ disabled: frontIdList.length, 'btn-attach': true }"
        >
          <span><em class="icon-adjuntar"></em> Adjuntar</span>
          <input
            type="file"
            #frontIdPic
            formControlName="frontIdPic"
            id="FrontIDPic"
            [accept]="allowedFileID.join()"
          />
        </label>

        <mat-error
          *ngIf="
            controlFrontIdPic.hasError('invalidDNI') &&
            !controlFrontIdPic.hasError('invalidFormat') &&
            controlFrontIdPic.touched
          "
        >
          La parte frontal de tu cédula no es válida, inténtalo nuevamente.
        </mat-error>

        <mat-error
          *ngIf="
            !controlFrontIdPic.hasError('invalidDNI') &&
            controlFrontIdPic.hasError('maxFileSize') &&
            controlFrontIdPic.touched
          "
        >
          Excediste el peso máximo del archivo, recuerda que no debe pesar más
          de {{ MAX_SIZE_ID }} MB
        </mat-error>

        <mat-error
          *ngIf="
            !controlFrontIdPic.hasError('invalidDNI') &&
            !controlFrontIdPic.hasError('maxFileSize') &&
            controlFrontIdPic.hasError('incorrectMimeType') &&
            controlFrontIdPic.touched
          "
        >
          No es posible adjuntar la cédula en este formato, intenta en formato
          .PDF, .JPG, .PNG.
        </mat-error>

        <mat-error
          class="mat-error-double"
          *ngIf="
            !controlFrontIdPic.hasError('invalidDNI') &&
            !controlFrontIdPic.hasError('maxFileSize') &&
            !controlFrontIdPic.hasError('incorrectMimeType') &&
            controlFrontIdPic.hasError('invalidFormat') &&
            !frontIdList.length &&
            controlFrontIdPic.value &&
            controlFrontIdPic.touched
          "
        >
          Error de formato en tu(s) archivo(s).
          <br />
          <strong>Revisa y sube nuevamente.</strong>
        </mat-error>

        <mat-error
          class="warning"
          *ngIf="
            !controlFrontIdPic.hasError('invalidDNI') &&
            !controlFrontIdPic.hasError('maxFileSize') &&
            !controlFrontIdPic.hasError('incorrectMimeType') &&
            !controlFrontIdPic.hasError('invalidFormat') &&
            !frontIdList.length &&
            controlFrontIdPic.touched
          "
        >
          <span>*</span>No olvides cargar tus documentos para poder continuar
        </mat-error>

        <div *ngIf="frontIdList.length">
          <div
            class="preview-file-attach front-id-pic-attach"
            *ngFor="let frontIdPic of frontIdList; let i = index"
          >
            <em class="icon-imagen"></em>
            <p>{{ frontIdPic.name }}</p>
            <button
              type="button"
              (click)="deleteFileArrayID(controlFrontIdPic, frontIdList, i)"
            >
              <em class="icon-salir"></em>
            </button>
          </div>
        </div>
      </div>

      <div class="attach-container back-id">
        <h3><strong>Reverso de tu cédula</strong></h3>
        <label
          for="BackIDPic"
          [ngClass]="{
            disabled: backIdList.length || !frontIdList.length,
            'btn-attach': true
          }"
        >
          <span><em class="icon-adjuntar"></em> Adjuntar</span>
          <input
            type="file"
            #backIdPic
            formControlName="backIdPic"
            id="BackIDPic"
            [accept]="allowedFileID.join()"
          />
        </label>

        <mat-error
          *ngIf="
            controlBackIdPic.hasError('invalidDNI') &&
            !controlBackIdPic.hasError('invalidFormat') &&
            controlBackIdPic.touched
          "
        >
          El reverso de tu cédula no es válido, inténtalo nuevamente.
        </mat-error>

        <mat-error
          *ngIf="
            !controlBackIdPic.hasError('invalidDNI') &&
            controlBackIdPic.hasError('maxFileSize') &&
            controlBackIdPic.touched
          "
        >
          Excediste el peso máximo del archivo, recuerda que no debe pesar más
          de {{ MAX_SIZE_ID }} MB
        </mat-error>

        <mat-error
          *ngIf="
            !controlBackIdPic.hasError('invalidDNI') &&
            !controlBackIdPic.hasError('maxFileSize') &&
            controlBackIdPic.hasError('incorrectMimeType') &&
            controlBackIdPic.touched
          "
        >
          No es posible adjuntar la cédula en este formato, intenta en formato
          .PDF, .JPG, .PNG.
        </mat-error>

        <mat-error
          class="warning"
          *ngIf="
            !controlBackIdPic.hasError('invalidDNI') &&
            !controlBackIdPic.hasError('maxFileSize') &&
            !controlBackIdPic.hasError('incorrectMimeType') &&
            !controlBackIdPic.hasError('invalidFormat') &&
            !backIdList.length &&
            controlBackIdPic.touched
          "
        >
          <span>*</span>No olvides cargar tus documentos para poder continuar
        </mat-error>
        <mat-error
          class="mat-error-double"
          *ngIf="
            !controlBackIdPic.hasError('invalidDNI') &&
            !controlBackIdPic.hasError('maxFileSize') &&
            !controlBackIdPic.hasError('incorrectMimeType') &&
            controlBackIdPic.hasError('invalidFormat') &&
            !backIdList.length &&
            controlBackIdPic.value &&
            controlBackIdPic.touched
          "
        >
          Error de formato en tu(s) archivo(s).
          <br />
          <strong>Revisa y sube nuevamente.</strong>
        </mat-error>

        <div *ngIf="backIdList.length">
          <div
            class="preview-file-attach back-id-pic-attach"
            *ngFor="let backIdPic of backIdList; let i = index"
          >
            <em class="icon-imagen"></em>
            <p>{{ backIdPic.name }}</p>
            <button
              type="button"
              (click)="deleteFileArrayID(controlBackIdPic, backIdList, i)"
            >
              <em class="icon-salir"></em>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="note" *ngIf="groupAttachWorkDocuments.enabled">
      <span class="number">2</span>
      <p class="content">
        Sube archivos con formato PDF, JPG o PNG que no tengan un peso mayor a
        {{ MAX_SIZE }} MB.
        <strong>(Verifica que el documento no tenga clave).</strong>
      </p>
    </div>
    <section
      class="card attach-box work-documents"
      formGroupName="attachWorkDocuments"
      *ngIf="groupAttachWorkDocuments.enabled"
    >
      <div class="attach-container work-certificate">
        <h3>
          Solo <strong>uno</strong> de estos documentos ¿Cuál de ellos deseas
          adjuntar?
        </h3>

        <mat-radio-group
          class="radio-button-upload-documents type-work-certificate"
          formControlName="typeWorkCertificate"
          *ngIf="radioButtonsWorkDocs.length"
        >
          <mat-radio-button
            [value]="radioButton"
            *ngFor="let radioButton of radioButtonsWorkDocs"
            >{{ radioButton.name }}</mat-radio-button
          >
        </mat-radio-group>

        <label
          for="WorkCertificate"
          [ngClass]="{
            disabled:
              !controlTypeWorkCertificate.valid ||
              workCertificatesDocsList.length >= 3,
            'btn-attach': true
          }"
        >
          <span><em class="icon-adjuntar"></em> Adjuntar</span>
          <input
            type="file"
            #workCertificate
            formControlName="workCertificate"
            id="WorkCertificate"
            multiple="true"
            [accept]="allowedFile.join()"
          />
        </label>

        <mat-error
          *ngIf="
            controlWorkCertificate.hasError('maxFileSize') &&
            controlWorkCertificate.touched
          "
        >
          El peso máximo permitido para tu archivo es {{ MAX_SIZE }} MB
        </mat-error>

        <mat-error
          *ngIf="
            !controlWorkCertificate.hasError('maxFileSize') &&
            controlWorkCertificate.hasError('incorrectMimeType') &&
            controlWorkCertificate.touched
          "
        >
          Los formatos permitidos son: PDF, JPG y PNG
        </mat-error>

        <mat-error
          *ngIf="
            !controlWorkCertificate.hasError('maxFileSize') &&
            !controlWorkCertificate.hasError('incorrectMimeType') &&
            controlWorkCertificate.hasError('maxFiles') &&
            controlWorkCertificate.touched
          "
        >
          La cantidad máxima permitida que puedes cargar es de tres archivos
        </mat-error>

        <mat-error
          class="warning"
          *ngIf="
            !controlWorkCertificate.hasError('maxFileSize') &&
            !controlWorkCertificate.hasError('incorrectMimeType') &&
            !controlWorkCertificate.hasError('maxFiles') &&
            !controlWorkCertificate.hasError('invalidFormat') &&
            !workCertificatesDocsList.length &&
            controlWorkCertificate.touched
          "
        >
          <span>*</span>No olvides cargar tus documentos para poder continuar
        </mat-error>

        <mat-error
          class="mat-error-double"
          *ngIf="
            !controlWorkCertificate.hasError('invalidDNI') &&
            !controlWorkCertificate.hasError('maxFileSize') &&
            !controlWorkCertificate.hasError('incorrectMimeType') &&
            controlWorkCertificate.hasError('invalidFormat') &&
            !workCertificatesDocsList.length &&
            controlWorkCertificate.value &&
            controlWorkCertificate.touched
          "
        >
          Error de formato en tu(s) archivo(s).
          <br />
          <strong>Revisa y sube nuevamente.</strong>
        </mat-error>

        <div *ngIf="workCertificatesDocsList.length">
          <div
            class="preview-file-attach work-certificate-attach"
            *ngFor="
              let workCertificate of workCertificatesDocsList;
              let i = index
            "
          >
            <em class="icon-imagen"></em>
            <p>{{ workCertificate.name }}</p>
            <button
              type="button"
              (click)="
                deleteFileArray(
                  controlWorkCertificate,
                  workCertificatesDocsList,
                  i
                )
              "
            >
              <em class="icon-salir"></em>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div
      class="note"
      *ngIf="
        groupAttachIndependentDocuments.enabled &&
        groupAttachWorkDocuments.disabled
      "
    >
      <span class="number" *ngIf="groupAttachIdGroup.disabled">1</span>
      <span class="number" *ngIf="groupAttachIdGroup.enabled">2</span>
      <p class="content">
        Sube archivos con formato PDF, JPG o PNG que no tengan un peso mayor a
        {{ MAX_SIZE }} MB.
        <strong>(Verifica que el documento no tenga clave).</strong>
      </p>
    </div>
    <section
      class="card attach-box independent-documents"
      formGroupName="attachIndependentDocuments"
      *ngIf="groupAttachIndependentDocuments.enabled"
    >
      <div class="attach-container independent-document">
        <h3>
          Solo <strong>uno</strong> de estos documentos ¿Cuál de ellos deseas
          adjuntar?
        </h3>

        <mat-radio-group
          class="radio-button-upload-documents type-independent-document"
          formControlName="typeIndependentDocument"
          *ngIf="radioButtonsIndependentDocs.length"
        >
          <mat-radio-button
            [value]="radioButton"
            *ngFor="let radioButton of radioButtonsIndependentDocs"
            >{{ radioButton.name }}</mat-radio-button
          >
        </mat-radio-group>

        <label
          for="IndependentDocument"
          [ngClass]="{
            disabled:
              !controlTypeIndependentDocument.valid ||
              independentDocsList.length >= 3,
            'btn-attach': true
          }"
        >
          <span><em class="icon-adjuntar"></em> Adjuntar</span>
          <input
            type="file"
            #independentDocument
            formControlName="independentDocument"
            id="IndependentDocument"
            multiple="true"
            [accept]="allowedFiles.join()"
          />
        </label>

        <mat-error
          *ngIf="
            controlIndependentDocument.hasError('maxFileSize') &&
            controlIndependentDocument.touched
          "
        >
          El peso máximo permitido para tu archivo es {{ MAX_SIZE }} MB
        </mat-error>

        <mat-error
          *ngIf="
            !controlIndependentDocument.hasError('maxFileSize') &&
            controlIndependentDocument.hasError('incorrectMimeType') &&
            controlIndependentDocument.touched
          "
        >
          Los formatos permitidos son: PDF, JPG y PNG
        </mat-error>

        <mat-error
          *ngIf="
            !controlIndependentDocument.hasError('maxFileSize') &&
            !controlIndependentDocument.hasError('incorrectMimeType') &&
            controlIndependentDocument.hasError('maxFiles') &&
            controlIndependentDocument.touched
          "
        >
          La cantidad máxima permitida que puedes cargar es de tres archivos
        </mat-error>

        <mat-error
          class="warning"
          *ngIf="
            !controlIndependentDocument.hasError('maxFileSize') &&
            !controlIndependentDocument.hasError('incorrectMimeType') &&
            !controlIndependentDocument.hasError('maxFiles') &&
            !independentDocsList.length &&
            controlIndependentDocument.touched
          "
        >
          <span>*</span>No olvides cargar tus documentos para poder continuar
        </mat-error>

        <div *ngIf="independentDocsList.length">
          <div
            class="preview-file-attach work-certificate-attach"
            *ngFor="
              let independentDocument of independentDocsList;
              let i = index
            "
          >
            <em class="icon-imagen"></em>
            <p>{{ independentDocument.name }}</p>
            <button
              type="button"
              (click)="
                deleteFileArray(
                  controlIndependentDocument,
                  independentDocsList,
                  i
                )
              "
            >
              <em class="icon-salir"></em>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="box-btn-submit">
      <button
        class="btn btn-degraded blue"
        type="submit"
        id="SubmitUploadDocumentsForm"
        [disabled]="
          !uploadIDSuccess ||
          (groupAttachWorkDocuments.enabled && !workCertificatesDocsList.length)
        "
      >
        Continuar
      </button>
    </div>
  </form>
</div>
